export const enableDownload = (row) => {
  if (
    row.activity &&
    row.activity.properties &&
    row.activity.properties !== undefined &&
    row.activity.properties.template &&
    row.activity.properties.template !== undefined &&
    row.result === "PASSED"
  ) {
    return true;
  } else if (row.result === "FAILED") {
    return true;
  } else false;
};
